module.exports = __webpack_public_path__ + "img/time.5148997c.svg";